import Task from "@mui/icons-material/Task";
import { type FC, useEffect } from "react";
import { Navigate, useNavigate } from "react-router";
import { RouteTabs } from "../../modules/generic/components/route-tabs";
import { Page } from "../../modules/layout/components/page";
import { PageHeader } from "../../modules/layout/components/page-header";
import { PageHeading } from "../../modules/layout/components/page-heading";
import { useFlags } from "../../server/optimizely";
import { InProgressTab } from "./components/in-progress-tab";
import { PreviousReviewsTab } from "./components/previous-reviews-tab";

const title = "Reviews | ChangeEngine";

const DefaultPage: FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    void navigate("/reviews/in-progress", { replace: true });
  });
  return null;
};

const ReviewsPage: FC = () => {
  const {
    flags: { reviewer_role: reviewEnabled },
    flagsLoaded,
  } = useFlags("reviewer_role");

  // Waiting on flagsLoaded, otherwise a direct visit bounces before the flags arrive.
  if (flagsLoaded && !reviewEnabled) return <Navigate replace to="/" />;

  return (
    <Page title={title}>
      <PageHeader>
        <PageHeading heading="Reviews" muiIcon={<Task />} />
      </PageHeader>
      <RouteTabs
        defaultPage={<DefaultPage />}
        base="/reviews/"
        preserveQuery
        tabs={[
          {
            type: "explicit",
            data: {
              name: "In progress",
              route: "in-progress",
              analyticsId: "reviews-tab-in-progress",
              // The tabs offer different statuses, so carrying one over selects an option the
              // other tab doesn't have.
              queryParamsToRemove: ["status"],
            },
            component: <InProgressTab />,
          },
          {
            type: "explicit",
            data: {
              name: "Previous reviews",
              route: "previous-reviews",
              analyticsId: "reviews-tab-previous-reviews",
              queryParamsToRemove: ["status"],
            },
            component: <PreviousReviewsTab />,
          },
        ]}
        title={title}
      />
    </Page>
  );
};

export default ReviewsPage;
